import Kfit from '../integrations/Kfit';

export default params =>
  Kfit.patch(`/v2/fave_deal/submit_deal_setup_request`, params).then(
    res => res
  );
